import { firstLetterCapitalize } from '../../../../utils/formatting';
import Entity from '../../../entity';
interface IBank {
  id: string;
  name: string;
  logoUrl?: string | null;
  logoBase64Encoding?: string | null;
}

interface IFinancialAccount {
  id: string;
  name: string;
  mask?: string | null;
  subtype?: string | null;
  bank: IBank;
}

interface IAccountPrimaryElementProps {
  financialAccount: IFinancialAccount;
}

const AccountPrimaryElement = ({ financialAccount }: IAccountPrimaryElementProps) => {
  const accountType = financialAccount.subtype
    ? firstLetterCapitalize(financialAccount.subtype.replace(/_/g, ' '))
    : '';
  const bankName = financialAccount.bank?.name || '';
  const accountMask = financialAccount.mask ? `••${financialAccount.mask}` : '';

  return (
    <div className="flex min-w-0 items-center gap-2">
      <Entity.Avatar entity={financialAccount} size="sm" />
      <div className="flex min-w-0 flex-col items-start">
        <span className="text-primary max-w-full truncate text-base font-medium">{financialAccount.name}</span>
        <div className="flex min-w-0 items-center gap-1">
          {accountType && (
            <>
              <span className="text-tertiary text-sm">{accountType}</span>
              {bankName && <span className="text-quaternary text-sm">|</span>}
            </>
          )}
          {bankName && (
            <>
              <span className="text-tertiary text-sm">{bankName}</span>
              {accountMask && <span className="text-quaternary text-sm">|</span>}
            </>
          )}
          {accountMask && <span className="text-tertiary text-sm">{accountMask}</span>}
        </div>
      </div>
    </div>
  );
};

export default AccountPrimaryElement;
